<template>
  <div class="selectrow">
    <label>Canton</label>
    <div class="row">
      <el-select
        filterable
        clearable
        :value="value"
        class="col-md-8 select-info"
        size="large"
        @input="$emit('input', $event)"
      >
        <el-option
          v-for="option in selects.canton"
          :value="option.value"
          :label="option.label"
          :key="option.value"
          class="select-info"
        />
      </el-select>
    </div>
  </div>
</template>

<script>
export default {
  name: 'SelectCanton',
  props: ['value'],
  data() {
    return {
      selects: {
        simple: '',
        canton: [
          {
            key: 'key',
            value: 'value',
          },
        ],
      },
    };
  },
  created() {
    this.fetchData();
    this.selects.simple = this.value;
  },
  methods: {
    fetchData() {
      return this.$http
        .get(`${process.env.VUE_APP_ANNUAIRE_API_URL}/cantonEntities?size=50`)
        .then(response => {
          this.selects.canton = response.data._embedded.cantonEntities.map(
            entity => ({
              value: entity.code,
              label: entity.name,
            }),
          );
        });
    },
  },
};
</script>

<style>
.form-group2 {
  margin-bottom: 10px;
}
.selectrow {
  padding-top: 5px;
}
.el-select .el-input.is-disabled .el-input__inner {
  cursor: not-allowed;
  color: #66615b;
  background-color: lightgray;
  border: #66615b;
}
</style>
